<template>
  <slot name="button" v-bind="{ toggle, label, selectedText }">
    <SelectModalSharedButton
      :label="label"
      :description="selectedText"
      @toggle="toggle"
      :loading="loading"
    />
  </slot>
  <NamiModal v-model="showModal" large>
    <NamiModalTitle
      @close="toggle"
      subtitle="Triple-state selection; can include or exclude"
    >
      {{ label }}
    </NamiModalTitle>
    <SelectModalContentTristate
      :included="included"
      :excluded="excluded"
      :included-mode="includedMode"
      :excluded-mode="excludedMode"
      :options="options"
      @update:included="(v) => $emit('update:included', v)"
      @update:excluded="(v) => $emit('update:excluded', v)"
      @update:included-mode="(v) => $emit('update:includedMode', v)"
      @update:excluded-mode="(v) => $emit('update:excludedMode', v)"
    />
    <NamiButton
      button-type="secondary"
      block
      @button-click="toggle"
      small
      class="mt-4"
    >
      Done
    </NamiButton>
  </NamiModal>
</template>

<script setup lang="ts" generic="T">
import type { Props as ContentProps } from "./content/Tristate.vue";

export type Props<T> = ContentProps<T> & {
  label: string;
  placeholder?: string;
  loading?: boolean;
};

const props = defineProps<Props<T>>();

const emit = defineEmits<{
  (e: "update:included", v: T[]): void;
  (e: "update:excluded", v: T[]): void;
  (e: "update:includedMode", v: "and" | "or"): void;
  (e: "update:excludedMode", v: "and" | "or"): void;
}>();

const showModal = ref(false);

function toggle() {
  showModal.value = !showModal.value;
}

const selectedText = computed(() => {
  const myIncluded = props.options.filter((o) =>
    props.included.includes(o.value),
  );
  const myExcluded = props.options.filter((o) =>
    props.excluded.includes(o.value),
  );

  if (myIncluded.length === 0 && myExcluded.length === 0) return "Any";

  return (
    (myIncluded.length > 0 ? "Include " : "") +
    myIncluded
      .map((o) => o.text)
      .join(props.includedMode === "and" ? " & " : " or ") +
    (myExcluded.length > 0
      ? myIncluded.length > 0
        ? " and exclude "
        : "Exclude "
      : "") +
    myExcluded
      .map((o) => o.text)
      .join(props.excludedMode === "and" ? " & " : " or ")
  );
});

defineExpose({
  selectedText,
});
</script>
